import { render, staticRenderFns } from "./Placement.vue?vue&type=template&id=2131658d&scoped=true"
import script from "./Placement.vue?vue&type=script&lang=js"
export * from "./Placement.vue?vue&type=script&lang=js"
import style0 from "./Placement.vue?vue&type=style&index=0&id=2131658d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2131658d",
  null
  
)

export default component.exports